import React, {useState, useEffect} from 'react'
import {Modal, Input, Row, Col, Upload, notification} from 'antd'


function CategoryModalEdit(props){
    const[nombre, setNombre] = useState(props.nameCategory);
    const [fileList, setFileList] = useState([]);

    useEffect (() => { 
        setNombre(props.nameCategory);
    }, [props.nameCategory])

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(nombre === "" && props.nameCategory !== ""){
            setNombre(props.nameCategory);
        }
        const editCategory = {
            image : "",
            mediaType : "",
            name : "",
            categoryName: nombre
        }
        if(fileList.length > 0){
            fileList.forEach(file => {
                const reader = new FileReader();
                const image = new Image(); 
                
                reader.readAsDataURL(file.originFileObj);
                reader.onload = ({ target }) => { 
                    const result = target.result; 
                    image.src = result;
                    const values = { 
                        name: file.name, 
                        size: file.size,
                        base64Data: result.split(",")[1], 
                        type: result.split(";")[0].split(":")[1] 
                    };
    
                    
                    editCategory.image = values.base64Data;
                    editCategory.mediaType = values.type;
                    editCategory.name = values.name;
                    
                    setFileList([]);
                    props.handleOkModalEdit(2,editCategory);
                    
                }; 
            });
        }else{
            props.handleOkModalEdit(1,editCategory);
        }
        
      };

    const handleCancel = () => {
        setFileList([]);
        props.handleCancelModalEdit();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const propsUpload = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
         
        },
        beforeUpload: (newFile ) => {
            if (newFile.type === 'image/png' || newFile.type === 'image/jpeg') {
                const oldList = [...fileList];
                oldList.push(newFile);
                setFileList(oldList);
                return false;
                
              }else{
                msNotification('warning', 'Categoría', `${newFile.name} el archivo no es .png o .jpg`);
                
              }
              return newFile.type === 'image/png' ? false : newFile.type === 'image/jpeg' ? false : Upload.LIST_IGNORE;
        },
        fileList,
        listType: "picture-card",
        onPreview: file => {
            let src = file.url;
            if (!src) {
              src = new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
              });
            }
            const image = new Image();
            image.src = src;
            const imgWindow = window.open(src);
            imgWindow.document.write(image.outerHTML);
        },
        onChange: ({ fileList: newFileList }) => {
            setFileList(newFileList);
        }
      };

    return(
        <React.Fragment>
            <Modal title="Editar Categoria" 
            visible={props.modalVisibleEdit} 
            onOk={handleOk} 
            onCancel={handleCancel}>
                <Row>
                    <Col span={24}>
                        <Input key={nombre} defaultValue={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={12}>
                        <Upload {...propsUpload}>
                            {fileList.length < 1 && '+ Upload'}
                        </Upload>
                    </Col>
                    <Col span={12}>
                        <img className="imgWidth" src={props.urlThumbnail}></img>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default CategoryModalEdit;



// WEBPACK FOOTER //
// ./src/components/CategoryModalEdit.jsx